import React from "react";

export default function NewsBanner() {
  return (
    <div className="!relative !overflow-hidden !rounded-2xl !bg-gradient-to-r !from-[#031d3f] !via-[#07397b] !to-[#0c53a6] !p-6 md:!p-7 !text-white !shadow-lg !border !border-blue-900/40">
      {/* Decorative background effects */}
      <div className="!absolute !-right-16 !-bottom-16 !w-80 !h-80 !rounded-full !bg-blue-400/10 !blur-3xl !pointer-events-none" />
      <div className="!absolute !left-1/3 !-top-12 !w-64 !h-64 !rounded-full !bg-cyan-400/10 !blur-2xl !pointer-events-none" />
      <div className="!absolute !inset-0 !bg-[radial-gradient(#ffffff0a_1px,transparent_1px)] ![background-size:16px_16px] !pointer-events-none !opacity-40" />

      <div className="!relative !z-10 !flex !flex-col lg:!flex-row lg:!items-center !justify-between !gap-5">
        {/* Left Column: Brand, Title & Subtitle */}
        <div className="!max-w-3xl !space-y-2.5">
          <div className="!flex !flex-wrap !items-center !gap-2.5">
            <span className="!inline-flex !items-center !gap-1.5 !px-3 !py-1 !rounded-full !text-sm !font-bold !tracking-wide !uppercase !bg-blue-500/20 !text-cyan-200 !border !border-cyan-400/30 !backdrop-blur-md">
              <span className="!w-2 !h-2 !rounded-full !bg-emerald-400 !animate-pulse" />
              Hệ thống Kho & Vật Tư ICOOL
            </span>
            <span className="!text-sm !text-blue-200/80 !font-medium !hidden sm:!inline-block">
              Kho Trung Tâm &bull; Bếp Trung Tâm &bull; Chi Nhánh
            </span>
          </div>

          <div>
            <h1 className="!text-2xl sm:!text-3xl !font-black !tracking-tight !text-white !drop-shadow-sm !flex !items-center !gap-3">
              <span>BẢNG TIN KHO</span>
            </h1>
            <p className="!text-blue-100/90 !text-sm sm:!text-base !font-normal !mt-1 !max-w-2xl !leading-relaxed">
              Theo dõi tổng hợp các phiếu nghiệp vụ chờ duyệt trong ngày và bảng
              tin thông báo điều hành toàn hệ thống.
            </p>
          </div>

          {/* Operational status badges */}
          <div className="!flex !flex-wrap !items-center !gap-2.5 !pt-1 !text-sm !text-blue-100">
            <div className="!inline-flex !items-center !gap-1.5 !bg-white/10 !px-3 !py-1.5 !rounded-lg !backdrop-blur-sm !border !border-white/10">
              <svg
                className="!w-4 !h-4 !text-cyan-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>
                Dữ liệu thống kê:{" "}
                <strong className="!text-white">Hôm nay</strong>
              </span>
            </div>

            <div className="!inline-flex !items-center !gap-1.5 !bg-white/10 !px-3 !py-1.5 !rounded-lg !backdrop-blur-sm !border !border-white/10">
              <svg
                className="!w-4 !h-4 !text-emerald-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>
                Trạng thái:{" "}
                <strong className="!text-emerald-300">Đang hoạt động</strong>
              </span>
            </div>
          </div>
        </div>

        {/* Right Column: Warehouse Badge */}
        <div className="!flex !items-center !gap-3 !shrink-0 !pt-2 lg:!pt-0 !border-t lg:!border-t-0 !border-white/10">
          <div className="!flex !items-center !gap-3 !bg-white/10 !backdrop-blur-md !px-4 !py-3 !rounded-xl !border !border-white/15 !text-sm !shadow-sm">
            <div className="!w-10 !h-10 !rounded-lg !bg-blue-600/60 !border !border-blue-400/40 !flex !items-center !justify-center !text-cyan-200">
              <svg
                className="!w-5 !h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                />
              </svg>
            </div>
            <div>
              <div className="!text-sm !text-blue-200 !font-medium">
                Kho ICOOL
              </div>
              <div className="!text-sm !font-bold !text-white !tracking-wide">
                BẢNG TIN NỘI BỘ
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
